import { UnitConfig } from "@enersis/gp-components/gp-kpi";

/**
 * Unit config for direct textual value.
 *
 * Why decimal category? - unit config category ask to provide category anyway (No error appears)
 * Why we need unit config for textual value? - slot placeholder doesnt work with angular binding, so noValueText doesnt popups
 */
export const TEXT_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: ""
};

export const NUMBER_FORMAT_DEFAULT = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
};

export const DECIMAL_NON_GROUPED_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "",
  omitUnits: ["k", "M", "G", "T"],
  numberFormat: {
    maximumFractionDigits: 0,
    maximumSignificantDigits: 10,
    useGrouping: false
  }
};

export const DECIMAL_GROUPED_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "",
  omitUnits: ["k", "M", "G", "T"],
  numberFormat: NUMBER_FORMAT_DEFAULT
};

export const DECIMAL_INTEGER_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "",
  omitUnits: ["k", "M", "G", "T"],
  numberFormat: NUMBER_FORMAT_DEFAULT
};

export const DECIMAL_W_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "k",
  unitSuffix: "W",
  omitUnits: [],
  numberFormat: NUMBER_FORMAT_DEFAULT
};

export const DECIMAL_WH_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "k",
  unitSuffix: "Wh",
  omitUnits: [],
  numberFormat: {
    ...NUMBER_FORMAT_DEFAULT,
    maximumSignificantDigits: undefined
  }
};

export const DECIMAL_KWH_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "k",
  unitSuffix: "Wh",
  omitUnits: ["M", "G", "T"],
  numberFormat: NUMBER_FORMAT_DEFAULT
};

export const DECIMAL_WHA_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "k",
  unitSuffix: "Wh/a"
};

export const DECIMAL_VA_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "k",
  unitSuffix: "VA"
};

export const WEITH_UNIT_CONFIG: UnitConfig = {
  category: "weight",
  base: "t"
};

export const getPercentageUnitConfig = (options?: {
  base?: "decimal" | "%";
  exact?: boolean;
  maximumFractionDigits?: number;
}): UnitConfig =>
  ({
    category: "percentage",
    base: options?.base ?? "decimal",
    valuePrefix: options?.exact ?? true ? null : "<",
    numberFormat: {
      minimumFractionDigits: 0,
      maximumFractionDigits: options?.maximumFractionDigits ?? 1,
      signDisplay: "never"
    }
  } as UnitConfig);

export const getPercentageWithSignUnitConfig = (options?: { base?: "decimal" | "%" }): UnitConfig => {
  const unitConfig = getPercentageUnitConfig(options);

  return {
    ...unitConfig,
    numberFormat: {
      ...unitConfig.numberFormat,
      signDisplay: "always"
    }
  };
};

export const CURRENCY_EUR_UNIT_CONFIG: UnitConfig = {
  category: "decimal",
  base: "",
  omitUnits: ["k", "M", "G", "T"],
  unitSuffix: "€",
  numberFormat: NUMBER_FORMAT_DEFAULT
};
